import { css } from "styled-components"
import { colors } from "../../helpers/colors"

export const SectionWrapperStyles = css``
export const ContentWrapperStyles = css`
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 3px;
  }
  // compatibility
  scrollbar-width: thin;
  scrollbar-color: ${colors.blue} transparent;
`
export const ContainerStyles = css``
export const WrapperStyles = css``
export const ModalImageStyles = css``
export const ModalVideoStyles = css``
